"use client";
import Banner from "@/components/Banner";
import Breadcrumbs from "@/components/Breadcrumbs";
import privacyPolicy from "./privacy_content.js";
import ArticleMarkdown from "@/components/Article/ArticleMarkdown";
import "@/components/Article/article.css";

const PrivacyPolicy = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <Banner
        BannerImage="https://cdn.msu.edu.in/msu-reavamp/banner/PrivacyPolicy1920x390px.webp"
        banner_name="Privacy Policy"
        banner_tag_line="Your privacy matters to us"
      />

      <Breadcrumbs
        items={[
          { label: "Privacy Policy", href: "/privacy-policy" },
        ]}
      />

      <section className="w-full flex justify-center">
        <div className="max-w-[var(--max-page-width)] w-full px-[var(--container-padding)] my-6 md:my-10 lg:my-14">
          <div className="grid grid-cols-1">
            <div className="bg-white w-full">
              <h1 className="font-extrabold text-[clamp(20px,3vw,42px)] text-black mb-4">
                Privacy Policy
              </h1>

              <p className="text-gray-600 mb-8">
                <strong>Effective Date:</strong> 3 August 2026
                <br />
                <strong>Last Updated:</strong> 3 August 2026
              </p>

              <div className="w-full [&_h2]:text-[#003B71]">
                <ArticleMarkdown markdown={privacyPolicy} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;